<template>
  <v-checkbox v-model="selected" class="merge-checkbox" @click.stop="toggleSelected" hide-details />
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapState } = createNamespacedHelpers("classifier");

/**
 * A simple checkbox component that handles all the logic about to
 * add or remove the given classification to the selected ones to merge
 * them.
 */
export default {
  props: {
    /**
     * The entire classification object to use in this component.
     */
    classification: {
      type: Object,
      required: true,
      validator: ({ id, name }) => !!id && !!name
    }
  },
  data: () => ({
    selected: false
  }),
  computed: {
    ...mapState(["selectedClassificationsForMerge"]),
    /**
     * A computed property that returns the index in the array if the classification
     * is in the selected array for merge or -1 other wise.
     */
    selectedIndex() {
      return this.selectedClassificationsForMerge.findIndex(
        ({ id }) => this.classification.id === id
      );
    }
  },
  methods: {
    ...mapMutations(["setSelectedClassificationsForMerge"]),
    /**
     * Change the selected status of this classification and add/remove it from the
     * selected classifications for merge.
     */
    toggleSelected() {
      this.selected = !this.selected;

      if (this.selectedIndex !== -1) {
        this.setSelectedClassificationsForMerge([
          ...this.selectedClassificationsForMerge.slice(0, this.selectedIndex),
          ...this.selectedClassificationsForMerge.slice(this.selectedIndex + 1)
        ]);
      } else {
        this.setSelectedClassificationsForMerge([
          ...this.selectedClassificationsForMerge,
          this.classification
        ]);
      }
    }
  },
  watch: {
    /**
     * Set the selected value of the checkbox according to the selected index.
     * Very useful if other component removes this classifications from the selected
     * ones.
     */
    selectedIndex() {
      this.selected = this.selectedIndex !== -1;
    }
  }
};
</script>

<style scoped>
.merge-checkbox {
  width: 24px;
  margin: auto;
}
</style>